import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=6b0ea85d&"
import script from "./SelectButton.vue?vue&type=script&lang=ts&"
export * from "./SelectButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports